<template>
  <div class="ViewAnalytics app-main-container">
    <h2 class="ViewAnalytics__title">
      Всегда актуальная аналитика, основанная на реальных данных
    </h2>
    <img src="/static/images/chart.png" alt="" class="ViewAnalytics__img" />
  </div>
</template>

<script>
export default {
  name: 'ViewAnalytics',
  components: {
    // AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
  },
  props: {},
};
</script>

<style lang="scss">
.ViewAnalytics {
  padding: 34px 25px;
  height: 100%;
  text-align: center;
  &__title {
    margin: 0;
    margin-bottom: 23px;
    font-size: 25px;
    font-weight: 700;
    line-height: 1.2;
    max-width: rem(560);
    margin-left: auto;
    margin-right: auto;
    @include media-xs() {
      margin-bottom: 15px;
      font-size: rem(20);
    }
  }
  &__img {
    max-width: 100%;
  }
}
</style>
